import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-conserverende-aanslag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-conserverende-aanslag.component.html',
  styleUrl: './tekst-conserverende-aanslag.component.scss',
})
export class TekstConserverendeAanslagComponent {}
